import script from "./UIInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIInfo.vue?vue&type=script&lang=ts&setup=true"

import "./UIInfo.vue?vue&type=style&index=0&id=8741598c&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8741598c"]])

export default __exports__